import React from "react";
import { Box, Flex, Heading, Text } from "theme-ui";
import { colors, typography } from "../../../styles/theme";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { graphql, useStaticQuery } from "gatsby";

const CustomerReviewHome = ({ clientLogos, testimonials, testimonialImage, subheading, testimonialTitle }) => {
    const {
        g2Badge1,
        g2Badge2,
        g2Badge3,
        g2Badge4,
        g2Badge5,
        g2Badge6,
        quote,
    } = useStaticQuery(graphql`
    query {
      g2Badge1: file(relativePath: { eq: "g2c/badge1.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, height: 166, layout: CONSTRAINED)
        }
      }
      g2Badge2: file(relativePath: { eq: "g2c/badge2.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, height: 166, layout: CONSTRAINED)
        }
      }
      g2Badge3: file(relativePath: { eq: "g2c/badge3.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, height: 166, layout: CONSTRAINED)
        }
      }
      g2Badge4: file(relativePath: { eq: "g2c/badge4.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, height: 166, layout: CONSTRAINED)
        }
      }
      g2Badge5: file(relativePath: { eq: "g2c/badge5.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, height: 166, layout: CONSTRAINED)
        }
      }
      g2Badge6: file(relativePath: { eq: "g2c/badge6.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, height: 166, layout: CONSTRAINED)
        }
      }
      quote: file(relativePath: { eq: "homeV1/quotes.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 30, layout: CONSTRAINED)
        }
      }
    }
  `);
    const quoteImage = getImage(quote);
    const g2Banners = [
        getImage(g2Badge1),
        getImage(g2Badge2),
        getImage(g2Badge3),
        getImage(g2Badge4),
        getImage(g2Badge5),
        getImage(g2Badge6),
    ];
    const testimonial = testimonials?.[0];

    return (
        <Flex sx={{ flexDirection: "column", my: ["4rem", "4rem", "7rem", "7rem"] }}>
            <Heading
                as="h2"
                sx={{
                    mb: "1.5rem",
                    ...typography.h2,
                    textAlign: "center",
                }}
            >
                The <Text sx={{ color: colors.primary700 }}>Customers</Text> have spoken
            </Heading>
            <Text sx={headingStyles}>{subheading}</Text>
            {clientLogos && (
                <Flex
                    sx={{
                        margin: "auto",
                        mb: ["3rem", "3rem", "1.5rem", "1.5rem"],
                        px: ["1rem", "1rem", "2rem", "auto"],
                    }}
                >
                    <GatsbyImage image={clientLogos} alt="client-logos" />
                </Flex>
            )}
            <Flex sx={customerOuterContainerStyles}>
                <Flex sx={customerLeftContainerStyles}>
                    <Box className="ImageContainer" sx={imageContainerStyles}>
                        <Flex className="glass300" sx={glassContainerStyles}>
                            <Text
                                dangerouslySetInnerHTML={{
                                    __html: testimonial?.employeeName,
                                }}
                                sx={{ ...typography.h3, mb: "0.75rem" }}
                            />
                            <Text
                                dangerouslySetInnerHTML={{
                                    __html: testimonial?.employeeDesignation,
                                }}
                                sx={{ ...typography.h4 }}
                            />
                        </Flex>
                        <Box className="colouredCircle" sx={colouredCircle}></Box>
                        <Box className="backgroundCircle" sx={backgroundCircleStyles}></Box>
                        <Box sx={{ "@media (max-width:424px)": { width: "21.875rem" } }}>
                            <GatsbyImage
                                image={testimonialImage}
                                alt={testimonial?.testimonialImageAltText}
                                style={customerImageStyles}
                            />
                        </Box>
                    </Box>
                    <Flex className="testimonialContainer" sx={testimonialContainerStyles}>
                        <Box
                            sx={{
                                position: "absolute",
                                top: ["3.125rem", "3.125rem", "5.625rem", "1.875rem"],
                            }}
                        >
                            <GatsbyImage
                                image={quoteImage}
                                alt="quote-image"
                                style={{ width: "1.875rem" }}
                            />
                        </Box>
                        <Heading
                            as="h2"
                            sx={{ ...typography.h2, color: colors.primary700 }}
                        >
                            {testimonialTitle}
                        </Heading>
                        <Text
                            dangerouslySetInnerHTML={{
                                __html: testimonial?.feedback,
                            }}
                            sx={{ ...typography.textMd400 }}
                        />
                    </Flex>
                </Flex>
                <Flex sx={g2ContainerStyles}>
                    {g2Banners.map((badge, i) => (
                        <Box
                            key={`g2-badge-${i}`}
                            sx={{
                                "@media (max-width:599px)": {
                                    width: "7rem",
                                },
                            }}
                        >
                            <GatsbyImage
                                image={badge}
                                alt={`G2crowd Badge ${i + 1}`}
                                imgStyle={{ objectFit: "contain", width: "100%" }}
                            />
                        </Box>
                    ))}
                </Flex>
            </Flex>
        </Flex>
    );
};

const {
    headingStyles,
    customerOuterContainerStyles,
    customerLeftContainerStyles,
    imageContainerStyles,
    glassContainerStyles,
    colouredCircle,
    backgroundCircleStyles,
    customerImageStyles,
    testimonialContainerStyles,
    g2ContainerStyles,
} = {
    headingStyles: {
        ...typography.textMd400,
        margin: "auto",
        textAlign: "center",
        width: ["100%", "100%", "100%", "50%"],
        mb: ["3rem", "3rem", "4rem", "3rem"],
        px: ["1rem", "1rem", "2rem", "auto"],
    },
    customerOuterContainerStyles: {
        px: ["0rem", "0rem", "2rem", "3.875rem"],
        gap: ["0.75rem", "0.75rem", "1.5rem", "1.5rem"],
        flexDirection: ["column", "column", "row", "row"],
        "@media (min-width:1441px)": {
            margin: "auto",
        },
        "@media (min-width:899px)": {
            flexDirection: "column",
            p: 0,
        },
        "@media (min-width:600px) and (max-width:750px)": {
            flexDirection: "column",
            p: 0,
        },
        "@media (max-width:899px)": {
            margin: "auto",
        },
    },
    customerLeftContainerStyles: {
        flexDirection: ["column", "column", "column", "row"],
        gap: ["0.75rem", "0.75rem", "1.5rem", "1.5rem"],
        "@media (min-width:899px) and (max-width:1436px)": {
            margin: "auto",
        },
        "@media (max-width:424px)": {
            width: "21.875rem",
            margin: "auto",
        },
        "@media (min-width:425px) and (max-width:599px)": {
            px: "1rem",
        },
    },
    imageContainerStyles: {
        width: ["24.188rem", "24.188rem", "26.125rem", "26.125rem"],
        height: ["28.625rem", "28.625rem", "35.563rem", "35.563rem"],
        position: "relative",
        margin: "auto",

        "@media (min-width:899px) and (max-width:1436px)": {
            margin: 0,
        },
        "@media (max-width:424px)": {
            width: "21.875rem",
        },
    },
    glassContainerStyles: {
        width: ["18.313rem", "18.313rem", "21.188rem", "33.688rem"],
        flexDirection: "column",
        position: "absolute",
        zIndex: 10,
        top: ["30.625rem", "23.125rem", "30.625rem", "25rem"],
        left: ["2.5rem", "1.875rem", "2.5rem", "17.5rem"],
        px: ["1rem", "1rem", "1.719rem", "3.584rem"],
        py: ["1rem", "1rem", "1.5rem", "2rem"],
        "@media (max-width: 899px)": {
            textAlign: "center",
        },
    },
    colouredCircle: {
        width: "4.375rem",
        height: "4.375rem",
        borderRadius: "50%",
        position: "absolute",
        bottom: ["-4.063rem", "-4.063rem", "-6.875rem", "1.25rem"],
        right: ["1.563rem", "1.563rem", "1.25rem", "-26.25rem"],
        zIndex: -99,
        backgroundColor: colors.primaryMain,
    },
    backgroundCircleStyles: {
        width: "100%",
        height: ["25.188rem", "25.188rem", "26.125rem", "26.125rem"],
        backgroundColor: colors.primaryMain,
        borderRadius: "50%",
        position: "absolute",
        top: ["0rem", "-2.5rem", "3.063rem", "3.063rem"],
        "@media (max-width:424px)": {
            width: "21.875rem",
        },
    },
    customerImageStyles: {
        position: "absolute",
        bottom: 0,
        margin: "auto",
        left: "50%",
        width: "100%",
        transform: "translateX(-50%)",
        "@media (max-width:424px)": {
            width: "100%",
        },
    },
    testimonialContainerStyles: {
        flexDirection: "column",
        width: ["100%", "100%", "30.188rem", "29.375rem"],
        pl: ["1.5rem", "1.5rem", "3rem", "3.719rem"],
        pr: ["1.5rem", "1.5rem", "3rem", "2.218rem"],
        pt: ["5.375rem", "5.375rem", "7.688rem", "3.513rem"],
        pb: ["3rem", "3rem", "4.5rem", "auto"],
        backgroundColor: colors.primary100,
        borderRadius: "1rem",
        zIndex: -999,
        position: "relative",
        "@media (max-width:599px)": {
            maxWidth: "26.75rem",
            margin: "auto",
        },
    },
    g2ContainerStyles: {
        flexWrap: "wrap",
        width: ["100%", "100%", "11rem", "22.75rem"],
        backgroundColor: colors.secondaryGreen100,
        borderRadius: "1.5rem",
        justifyContent: "center",
        py: "1.5rem",
        px: ["1.344rem", "1.344rem", "1.5rem", "3rem"],
        gap: "0.75rem",

        "@media (min-width:899px)": {
            width: "57.813rem",
            margin: "auto",
        },
        "@media (min-width:600px) and (max-width:750px)": {
            width: "30.188rem",
        },
        "@media (min-width:899px) and (max-width:899px)": {
            width: "30.188rem",
        },
        "@media (min-width:425px) and (max-width: 599px)": {
            width: "25.188rem",
            margin: "auto"
        }
    },
};

export default CustomerReviewHome;
